<template>
  <BlueprintsContainer />
</template>

<script lang="ts">
import Vue from "vue";
import BlueprintsContainer from "@/components/projects/project/blueprints/container/Blueprints_Container.vue";

export default Vue.extend({
  components: {
    BlueprintsContainer,
  },
});
</script>
